import {GET_REPORT_PAYMENT, GET_REPORT_PRODUCTS, CLEAR_REPORTS, GET_REPORT_RE_OFFER_ACTION, GET_REPORT_DASHBOARD, GET_REPORT_DELIVERIES_BY_BAIRRO_ENTREGADOR} from '../actions/types';

const reportsReducer = (state = {}, action) => {
	switch(action.type){
    case GET_REPORT_PAYMENT:
      return {
        ...state,
        payments: action.payload.payments
      }
    case GET_REPORT_PRODUCTS:
      return {
        ...state,
        products: action.payload.products
      };
    case GET_REPORT_DASHBOARD:
      return {
        ...state,
        dashboard: action.payload
      };
    case GET_REPORT_DELIVERIES_BY_BAIRRO_ENTREGADOR:
      return {
        ...state,
        deliveriesByBairroEntregador: action.payload.lines
      };
    case GET_REPORT_RE_OFFER_ACTION:
      return {
        ...state,
        reOfferReducer: action.payload.reOfferRows
      };
    case CLEAR_REPORTS:
      return {
        ...state,
        payments: null,
        products: null,
        dashboard: null,
        deliveriesByBairroEntregador: null
      }
    default:
      return state;
	}
};

export default reportsReducer;